import { FC, useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useExpansionListShortened } from "hooks";
import { ProductShortened, SelectOption } from "types";
import { CustomSelect } from "core";
import { getExpansionName } from "modules/expansions/business";

type ExpansionFilterAvailableProps = {
  productList: ProductShortened[];
};

export const ExpansionFilterAvailable: FC<ExpansionFilterAvailableProps> = ({
  productList,
}) => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { isLoading, expansionList } = useExpansionListShortened();

  const [expansion, setExpansion] = useState<SelectOption | null>(null);

  const expansionOptionList = useMemo(
    () =>
      expansionList
        .filter((expansion) =>
          productList.some((product) => product.expansionID === expansion.id),
        )
        .map((expansionOption) => {
          return {
            label: getExpansionName(expansionOption),
            value: expansionOption.id,
          };
        }),
    [expansionList, productList],
  );

  console.log("ExpansionFilterAvailable productList", productList);
  console.log("ExpansionFilterAvailable expansionList", expansionList);
  console.log(
    "ExpansionFilterAvailable expansionOptionList",
    expansionOptionList,
  );

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const expansionIDParam = searchParams.get("expansionID");

    const selectedExpansion = expansionOptionList.find(
      (expansionOption) => expansionOption.value === expansionIDParam,
    );
    const selectedExpansionOption = selectedExpansion ?? null;

    setExpansion(selectedExpansionOption);
  }, [expansionOptionList, isLoading, searchParams]);

  return (
    <CustomSelect<SelectOption>
      label="Edition"
      options={expansionOptionList}
      onChange={(expansionOption) => {
        setExpansion(expansionOption);
        if (!expansionOption) {
          searchParams.delete("expansionID");
        } else {
          searchParams.set("expansionID", expansionOption.value);
        }
        sessionStorage.setItem(pathname, searchParams.toString());
        setSearchParams(searchParams, {
          replace: true,
        });
      }}
      value={expansion}
      placeholder="Filter nach Edition"
      isClearable={true}
    />
  );
};
